
import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import ThreeDBar from './views/ThreeDBar/ThreeDBar';
import SpiralCurve from './views/SpiralCurve/SpiralCurve';
import NormalSurface from './views/NormalSurface/NormalSurface';
import Sphere from './views/Sphere/Sphere';
import MapGraph from './views/MapGraph/MapGraph';
import FlowMap from './views/FlowMap/FlowMap';
import SceneGraph from './views/SceneGraph/SceneGraph';
import DriveImage from './views/DriveImage/DriveImage';
import Home from './views/Home/Home';
import Navbar from './compoments/Navbar';
import React, { Component } from 'react'


class App extends Component {
  render() {
    return (
    <BrowserRouter>
        <div className="App">
          <Navbar />
        </div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ThreeDBar" element={<ThreeDBar />} />
          <Route path="/SpiralCurve" element={<SpiralCurve />} />
          <Route path="/NormalSurface" element={<NormalSurface />} />
          <Route path="/Sphere" element={<Sphere />} />
          <Route path="/MapGraph" element={<MapGraph />} />
          <Route path="/FlowMap" element={<FlowMap />} />
          <Route path="/SceneGraph" element={<SceneGraph />} />
          <Route path="/DriveImage" element={<DriveImage />} />
        </Routes>
    </BrowserRouter>
    );
  };
}
export default App;